export function AustriaFlag({ className = "h-6 w-9" }) {
  return (
    <svg viewBox="0 0 36 24" className={className} aria-hidden focusable="false">
      <rect x="0.5" y="0.5" width="35" height="23" fill="#ffffff" stroke="currentColor" strokeOpacity="0.25" />
      <rect x="0.5" y="0.5" width="35" height="7.67" fill="#C8102E" />
      <rect x="0.5" y="15.83" width="35" height="7.67" fill="#C8102E" />
    </svg>
  );
}

export default function Logo({ tagline = true, className = "" }) {
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <AustriaFlag className="h-7 w-10 shrink-0 text-foreground" />
      <span className="flex flex-col leading-none">
        <span className="font-display text-lg font-700 uppercase tracking-tight text-foreground">
          Impexmiltrade
        </span>
        {tagline && (
          <span className="mono-label mt-1 text-[0.6rem] tracking-[0.35em] text-muted-foreground">
            Austria
          </span>
        )}
      </span>
    </span>
  );
}
